define('formkit/view/form.object/content/currency.input.content.view',['require','exports','module','uikit/uikit','./numeric.input.content.view','../../../templates','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                   = require('uikit/uikit'),
      NumericInputContentView = require('./numeric.input.content.view'),
      Templates               = require('../../../templates'),
      Radio                   = require('backbone.radio');

  var PreviewAnswerView = NumericInputContentView.PreviewAnswerView.extend({
    internalViewOptions: NumericInputContentView.PreviewAnswerView.extendInternalViewOptions({
      inputView: function() {
        return {
          type: UIKit.InputCurrency,
          placeholder: 'Please enter a dollar amount...',
          inputType: 'text',
          icon: 'dollar',
          fluid: true,
        };
      },
    }),

    initialize: function() {
      NumericInputContentView.PreviewAnswerView.prototype.initialize.apply(this, arguments);
    },
  });

  var CurrencyInputContentView = NumericInputContentView.extend({
    internalViewOptions: NumericInputContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
        };
      },
    }),
  });

  CurrencyInputContentView.PreviewAnswerView = PreviewAnswerView;

  module.exports = CurrencyInputContentView;
});

